import { Injectable } from '@angular/core';
import { ConsumerJsonModel } from './consumer.json.model';
import { AppCollection } from '../app.config';
import { BaseCollectionService } from '../core/jsonApi/BaseCollectionService';

@Injectable({
  providedIn: 'root'
})
export class ConsumerService extends BaseCollectionService<ConsumerJsonModel, AppCollection> {
  protected ctor = ConsumerJsonModel;
}
